const Health = () => {
  return (
    <div>
      <label>OK</label>
    </div>
  )
}

export default Health
